import React, { useEffect, useRef, useState } from "react";
import { findWhere, isNull, isUndefined } from "underscore";
import { NoPaddingGrid } from "../../../../containers/FleetManager/FleetManagerDataTable/StyledComponents";
import {
  DataTableContextFilters,
  DateFilter as DateFilterType,
  useDataTableContext,
} from "../../DataTableContext/DataTableContextProvider";
import { FilterType, IFilter } from "../DataTableFilters";
import DatePicker from "./DatePicker/DatePicker";

interface IDateFilter {
  filter: IFilter;
}

const DateFilter: React.FC<IDateFilter> = ({ filter }) => {
  const { state, setFilter } = useDataTableContext();

  const resetInternalRef = useRef<() => void>(() => {});

  useEffect(() => {
    if (!isUndefined(state.filters)) {
      const found = findWhere(state.filters as DataTableContextFilters[], {
        key: filter.key,
      });

      const dateFilter = found?.value as DateFilterType | undefined;
      if (!dateFilter) {
        return;
      }

      const { startDate, endDate } = dateFilter;
      if (isNull(startDate) && isNull(endDate)) {
        resetInternalRef.current();
      }
    }
  }, [state.filters]);

  const setStartEndDate = (startDate: Date | null, endDate: Date | null) => {
    setFilter(filter.key, filter.type as FilterType, {
      startDate,
      endDate,
      customKeys: filter.customDateKeys,
    });
  };

  return (
    <NoPaddingGrid
      item
      container
      direction="column"
      justifyContent="center"
      xs={2}
    >
      <DatePicker
        resetRef={resetInternalRef}
        size="small"
        placeholder={filter.placeholder}
        onDateSelected={setStartEndDate}
      />
    </NoPaddingGrid>
  );
};

export default DateFilter;
